module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAMAAADXEh96AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURf////////////////WlDnMAAAADdFJOU+eHBst6qUIAAAAdSURBVAjXY2BiZGBgZGJgZAYCIBNEMcAoqCBECQAFagBBDr5DuwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expanded-project-path-3@2x.png
// module id = 170
// module chunks = 0